<template>
  <div class="card p-3">
    <div class="fw-bold mb-2">{{ title }}</div>

    <canvas
      ref="canvas"
      class="border rounded w-100"
      height="180"
      @mousedown="start"
      @mousemove="draw"
      @mouseup="end"
      @mouseleave="end"
      @touchstart.prevent="start"
      @touchmove.prevent="draw"
      @touchend.prevent="end"
    />

    <div class="mt-2 d-flex gap-2">
      <button class="btn btn-outline-secondary btn-sm" @click="clear">
        Xóa
      </button>
      <button class="btn btn-primary btn-sm" @click="save">
        Xác nhận ký
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const props = defineProps({
  title: { type: String, default: "Ký tên" },
});
const emit = defineEmits(["signed"]);

const canvas = ref(null);
let ctx;
let drawing = false;

onMounted(() => {
  ctx = canvas.value.getContext("2d");
  ctx.lineWidth = 2;
  ctx.lineCap = "round";
  ctx.strokeStyle = "#000";
});

function getPos(e) {
  const rect = canvas.value.getBoundingClientRect();
  if (e.touches) {
    return {
      x: e.touches[0].clientX - rect.left,
      y: e.touches[0].clientY - rect.top,
    };
  }
  return {
    x: e.clientX - rect.left,
    y: e.clientY - rect.top,
  };
}

function start(e) {
  drawing = true;
  const { x, y } = getPos(e);
  ctx.beginPath();
  ctx.moveTo(x, y);
}

function draw(e) {
  if (!drawing) return;
  const { x, y } = getPos(e);
  ctx.lineTo(x, y);
  ctx.stroke();
}

function end() {
  drawing = false;
}

function clear() {
  ctx.clearRect(0, 0, canvas.value.width, canvas.value.height);
}

function save() {
  const dataUrl = canvas.value.toDataURL("image/png");
  emit("signed", dataUrl);
}
</script>
